<template>
  <div
    class="youcontrol"
    :style="`--nav-bar: ${mini ? 15 : 340}px;`">
    <div
      class="nav-bar-btn"
      :class="{'show-navBar': !mini}"
      data-qa="btn-collapse-navBar"
      @click="changeNavbarState(!mini)">
      <sIcon
        class="my-auto mx-auto"
        :rotate="mini ? 0 : 180"
        size="10"
        type="double-arrow"/>
    </div>
    <iframe
      ref="myIframe"
      class="youcontrol__iframe"
      sandbox="allow-same-origin allow-storage-access-by-user-activation allow-scripts allow-modals allow-popups allow-downloads allow-popups-to-escape-sandbox"
      :src="iframeHref"
      title="youcontrol"
      width="400"/>

    <div
      class="selected-members pa-0 pt-8 main__green">
      <sButton
        v-if="useTestBtn"
        data-qa="test-values"
        style="position: fixed; top: 0; right: 0;"
        @click="test">
        test
      </sButton>
      <sIcon
        v-if="!mini && loading"
        class="mx-auto"
        color="var(--secondary__green_not_active)"
        size="30"
        spin
        type="loading"/>
      <div
        v-else-if="!mini && !(companis && companis.length)"
        class="px-4">
        <div class="pl-2 pr-1 flex wrap h4-headline align-center">
          {{ $t('Tenders.NoAnyParticipants') }}
        </div>
        <div class="mt-3 pl-2 h6-text text-start">
          {{ $t('Tenders.YCBlockHint') }}
        </div>
      </div>
      <div
        v-else-if="!mini"
        class="px-2 main__green width-100"
        elevation="0">
        <div class="pl-2 flex wrap h4-headline py-2 pr-1">
          {{ $t('Common.Check') }}
          <span class="secondary__green_not_active--text ml-2 pt-1 h7-text-medium">{{ companis && companis.length ? companis.length : 0 }}</span>
          <sButton
            class="btn h11-links-bold ml-auto"
            :disabled="loading"
            icon="delete"
            small
            type="text"
            @click="deleteAll">
            {{ $t('Common.Clear') }}
          </sButton>
        </div>
        <CartList
          key-field="email"
          :list="companis">
          <template #item-title="{ item }">
            {{ item.email || '-' }}
          </template>
          <template #item-additional="{ item }">
            <div
              v-if="item.name">
              {{ item.name }}
            </div>
          </template>
          <template #item-action="{ item }">
            <sButton
              :disabled="loading"
              icon="delete"
              small
              type="green"
              @click="clickSelect(item, true)"/>
          </template>
        </CartList>
      </div>
    </div>
  </div>
</template>
<script>
import CartList from 'components/common/blocks/CartList.vue'

import { storageMixin } from 'mixins'
import youcontrol from 'mixins/youcontrol.js'
import displaySize from 'mixins/display-size'

export default {
  name: 'YoucontrolStep',
  mixins: [ displaySize, youcontrol, storageMixin ],
  data() {
    return {
      mini: false,
      loading: false,
      companis: [],
    }
  },
  methods: {
    test() {
      this.companis = JSON.parse('[{"email":"mail1@mail1.trading","name":"ТОВ \\"Д.ТРЕЙДІНГ\\"","code":"42751799"},{"email":"mail2@mail2.gov.ua","name":"АТ \\"НАЦІОНАЛЬНА АТОМНА ЕНЕРГОГЕНЕРУЮЧА КОМПАНІЯ \\"ЕНЕРГОАТОМ\\"","code":"24584661"}]')
    },
    changeNavbarState(result) {
      this.mini = result
      this.$_savePropToDBStorage('layoutNavbarMini', this.mini)
    },
    deleteAll() {
      this.companis = []
    },
    checkResultYoucontrol(props) {
      if (!props?.length) {
        return
      }
      const result = this.$_getUniqueEmails(props)
      this.companis = result.info
    },
    clickSelect(item) {
      const index = this.companis.findIndex(i => i.email === item.email)
      if (index === -1) {
        return
      }
      this.companis.splice(index, 1)
    }
  },
  computed: {
    /**
     * При локальной разработке не работает Youcontrol
     */
    useTestBtn() {
      return window?.config?.node_env === 'development'
    }
  },
  created() {
    if (this.breakpoint.smAndDown) {
      this.changeNavbarState(true)
    } else {
      this.$_getPropFromDBStorage('layoutNavbarMini', false)
        .then((result) => {
          this.changeNavbarState(result || result === 'true')
        })
    }
    try {
      this.companis = JSON.parse(this.$_getPropFromLocalStorage('youcontrolTender', [], true) || '[]')
    } catch {
      this.companis = []
    }
  },
  components: {
    CartList
  },
  watch: {
    companis: {
      //immediate: true,
      deep: true,
      handler(newValue) {
        this.$_savePropToLocalStorage('youcontrolTender', JSON.stringify(newValue), true)
      }
    }
  },
  props: {
    tender: {
      type: Object
    },
    rules: {
      type: Object
    }
  }
}
</script>
<style lang="scss">
.yc-market .main-content {
  height: calc(100% - 74px);
}
</style>
<style scoped lang="scss">
.youcontrol {
  position: relative;
  display: grid;
  grid-template-columns: calc(100% - var(--nav-bar)) var(--nav-bar);
  height: 100%;
  gap: 10px;
  transition: all 0.25s;
}
.youcontrol__iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

.nav-bar-btn {
  position: absolute;
  right: 0px;
  top: 10px;
  z-index: 10;
  background: var(--v-secondary__green_chosen-base);
  width: 30px;
  height: 30px;
  line-height: 1;
  border-radius: 50px;
  cursor: pointer;
  display: flex;
  transition: all 0.25s;
  border: 2px solid var(--v-main__green-base) !important;
  &.show-navBar {
    right: 325px;
  }
}
.selected-members {
  height: 100%;
  width: 100%;
  align-items: end;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}
</style>
